/**
 * The item of `items` that best fits `wanted`, column by column from the left
 * (the order of `keys`): each choice is kept when the items left over offer
 * it, and otherwise falls back to the first that do. So changing one column
 * keeps the columns to its right where the new choice comes with them, and
 * with nothing wanted it is the top option of each column — as long as
 * `items` are listed in the order the picker shows the options.
 */
export var resolveChoice = function (items, getChoice, keys, wanted) {
    return keys.reduce(function (remaining, key) {
        var offering = remaining.filter(function (item) { return getChoice(item)[key] === wanted[key]; });
        if (offering.length > 0)
            return offering;
        var first = remaining[0] && getChoice(remaining[0])[key];
        return remaining.filter(function (item) { return getChoice(item)[key] === first; });
    }, items)[0];
};
